import axios from "../../core/axios";
import { assertSuccess } from "../../core/assert";
import { paramsParser } from "../../core/paramsParser";
import { Headers } from "../../resources";
import type {
  CollectionResult,
  MessageResult,
  NovelReadMarkerApplyParams,
  NovelReadMarkerEntity,
  NovelReadMarkerListParams,
  Result,
} from "../../types";

export class NovelReadMarker {
  static async find(params: NovelReadMarkerListParams, auth: string) {
    const resp = await axios.get<CollectionResult<NovelReadMarkerEntity>>(
      `/title/${params.titleId}/novel/read` +
        paramsParser({ ...params, titleId: undefined }),
      {
        responseType: "json",
        headers: Headers.Bearer(auth),
      },
    );

    return assertSuccess(resp.data);
  }

  static async get(titleId: string, auth: string) {
    const resp = await axios.get<Result<NovelReadMarkerEntity>>(
      `/title/${titleId}/novel/read`,
      {
        responseType: "json",
        headers: Headers.Bearer(auth),
      },
    );

    return assertSuccess(resp.data).data;
  }

  static async apply(body: NovelReadMarkerApplyParams, auth: string) {
    const resp = await axios.post<MessageResult<"Read Markers applied">>(
      `/title/${body.titleId}/novel/read`,
      {
        add: [],
        remove: [],
        ...body,
      },
      {
        responseType: "json",
        headers: Headers.Bearer(auth),
      },
    );

    return assertSuccess(resp.data);
  }
}
